__turbopack_context__.v({
  "Animate": "lcTm9G_Animate",
  "Content": "lcTm9G_Content",
  "OpenOverButton": "lcTm9G_OpenOverButton",
  "Popover": "lcTm9G_Popover",
  "Root": "lcTm9G_Root",
  "Root--Filter": "lcTm9G_Root--Filter",
  "Root--Full": "lcTm9G_Root--Full",
  "Root--FullWidth": "lcTm9G_Root--FullWidth",
  "Root--RightAligned": "lcTm9G_Root--RightAligned",
  "Root--Tight": "lcTm9G_Root--Tight",
  "ToggleButton": "lcTm9G_ToggleButton",
  "skeleton-loading": "lcTm9G_skeleton-loading",
});
